function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "ffmcci7cxa",
  d: "M0 0.004L22.001 0.004 22.001 34.186 0 34.186z"
}), /*#__PURE__*/React.createElement("path", {
  id: "g2mi9a1n2c",
  d: "M0 0.004L11.001 0.004 11.001 34.186 0 34.186z"
}), /*#__PURE__*/React.createElement("path", {
  id: "u67iyx6xbe",
  d: "M0.408 0.004L11.409 0.004 11.409 9.326 0.408 9.326z"
}), /*#__PURE__*/React.createElement("path", {
  id: "2hmp9m5sjg",
  d: "M0 0.004L11.001 0.004 11.001 9.326 0 9.326z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .81)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "arj6d6i7lb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ffmcci7cxa"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#B6DCFF",
  d: "M20.999.004h-5.43c-.394 0-.752.231-.914.59-.646 1.436-2.08 2.363-3.655 2.363-1.572 0-3.006-.927-3.653-2.362-.162-.36-.52-.591-.915-.591h-5.43C.449.004 0 .452 0 1.005v32.18c0 .552.448 1.001 1.003 1.001h5.43c.394 0 .752-.231.914-.59.646-1.436 2.08-2.363 3.653-2.363 1.575 0 3.008.927 3.655 2.363.161.359.52.59.914.59h5.43c.554 0 1.002-.449 1.002-1.001V1.005c0-.553-.448-1.001-1.002-1.001",
  mask: "url(#arj6d6i7lb)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .81)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "j3njb2puyd",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#g2mi9a1n2c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#D7EEFF",
  d: "M11 2.957c-1.573 0-3.007-.927-3.653-2.363-.162-.359-.52-.59-.914-.59h-5.43C.448.004 0 .452 0 1.005v32.18c0 .553.449 1.001 1.002 1.001h5.43c.395 0 .753-.23.915-.59.646-1.436 2.08-2.364 3.654-2.364V2.957z",
  mask: "url(#j3njb2puyd)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.593 .81)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "iyic0ezuqf",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#u67iyx6xbe"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0B4178",
  d: "M11.409 9.326v-8.32c0-.554-.449-1.002-1.002-1.002H4.976c-.394 0-.752.232-.914.59C3.416 2.03 1.982 2.958.408 2.958v6.369H11.41z",
  mask: "url(#iyic0ezuqf)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .81)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "ryvw229rrh",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#2hmp9m5sjg"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#2880C9",
  d: "M11 2.957c-1.573 0-3.007-.927-3.653-2.363-.162-.359-.52-.59-.914-.59h-5.43C.448.004 0 .452 0 1.005v8.32h11V2.958z",
  mask: "url(#ryvw229rrh)"
})));

var SvgBooking = function SvgBooking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBooking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/booking.af3a0280.svg";
export { ForwardRef as ReactComponent };